const checkSrc = '../../../assets/icons/check_green.svg';
export const features = [
  {
    name: ' Residential & Commercial Listings',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: ' Term of Listing',
    basic: {
      content: '6 Months',
      imageUrl: '',
    },
    standard: {
      content: '6 Months',
      imageUrl: '',
    },
    premium: {
      content: '1 Year',
      imageUrl: '',
    },
    deluxe: {
      content: '1 Year',
      imageUrl: '',
    },
  },
  {
    name: ' Listing in the Local REALTOR® Multiple Listing Service (MLS)',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '  Bright MLS, Homedatabase.com',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: 'Realtor.com®, Zillow, Trulia, Homes.com',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: ' ListHub Syndication Sites - Click to see all 156 sites we feed to ',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: ' Assist2Sell, ByOwner, Berkshire Hathaway, Century 21,ColdwellBanker.com, Keller Williams, RealtyExecutives, Redfin, ReMax',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '  You set the sale commission',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '  No commission if you find the Buyer',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: '',
    },
  },
  {
    name: '  Toll Free Number with 24/7 Audio Descriptions & your Contact  Info',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: ' Forms needed to write up a Purchase Agreement',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: 'Any email leads we receive on your property are scanned & electronically forwarded to you within minutes',
    basic: {
      content: '',
      imageUrl: checkSrc,
    },
    standard: {
      content: '',
      imageUrl: checkSrc,
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },

  {
    name: 'Ability to withdraw prior to expiration fee',
    basic: {
      content: '25$',
      imageUrl: '',
    },
    standard: {
      content: '25$',
      imageUrl: '',
    },
    premium: {
      content: 'No fee',
      imageUrl: '',
    },
    deluxe: {
      content: '$250',
      imageUrl: '',
    },
  },
  {
    name: 'No. of Photos in MLS ',
    basic: {
      content: '6 Photos',
      imageUrl: '',
    },
    standard: {
      content: 'Max MLS Allows',
      imageUrl: '',
    },
    premium: {
      content: 'Max MLS Allows',
      imageUrl: '',
    },
    deluxe: {
      content: 'Max MLS Allows',
      imageUrl: '',
    },
  },
  {
    name: 'Telephone Inquiries are',
    basic: {
      content: 'Given Your Number',
      imageUrl: '',
    },
    standard: {
      content: 'Given Your Number',
      imageUrl: '',
    },
    premium: {
      content: 'Transferred to you',
      imageUrl: '',
    },
    deluxe: {
      content: 'Transferred to you',
      imageUrl: '',
    },
  },
  {
    name: 'Caller ID information e-Mailed &/or texted for each call ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: 'Traditional Sign incl. promotes your property instead of our service ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: ' 24/7 Text-on-Demand of your property info',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '    Text on demand rider for lawn sign tells passersby to text for Info ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '  Open House Ads (up to 25 in MLS which syndicate to top websites like Realtor.com, Zillow, etc.) ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: '   Showing Time Appointment Service  ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: checkSrc,
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
  {
    name: 'Full Service: We will field offers, prepare paperwork, negotiate deals, interface with the buyers broker, closing agent (title co. or attorney), mortgage company, appraiser,etc. Includes after hours phone extension when offers come in evenings and weekends. ',
    basic: {
      content: '',
      imageUrl: '',
    },
    standard: {
      content: '',
      imageUrl: '',
    },
    premium: {
      content: '',
      imageUrl: '',
    },
    deluxe: {
      content: '',
      imageUrl: checkSrc,
    },
  },
];

export const Add_Plans = {
  "packageid": "12772441",
  "name": "Full Service 1% Cost at Settlement",
  "price": 0,
  "price_footnote": "*",
  "price_footnote_link": "0",
  "plus": null,
  "plus_type": null,
  "plus_display": null,
  "regular_price": 0,
  "price_comment": "Full Service 1% Cost at Settlement.",
  "listing_term": "12",
  "services": {
    "21": true,
    "23": true,
    "24": true,
    "25": true,
    "27": true,
    "29": "Max MLS Allows",
    "38": true,
    "40": "<font color=\"#C41200\"><b>Transferred 2U</b></font>",
    "41": "<b>1 year</b>",
    "51": true,
    "64": true,
    "148": "<font face=\"Arial\">No Fee</font>",
    "157": true,
    "159": true,
    "160": true,
    "165": true,
    "172": true,
    "428": true,
    "429": true,
    "436": true,
    "rescom": true
  }
};
